import { request, plannerRequest, requestV3 } from 'Features/Auth/axios-client'
import { useMutation, useQuery } from '@tanstack/react-query'
import { useCreateProjectDataParams } from '../ProjectList/ProjectList.types'
import { ProjectParamsInterface } from './CreateProject.types'

const fetchSnapshotList = async () => {
  const { data } = await request({
    url: `/snapshots`,
  })
  return data
}

export const useSnapshotData = () => {
  return useQuery({
    queryKey: ['snapshots'],
    queryFn: fetchSnapshotList,
    select: (data) => data.data,
  })
}

// /source-sites GET API call using plannerRequest
const fetchSourceSites = async () => {
  const { data } = await plannerRequest({
    url: `/source-sites`,
  })
  return data
}

export const useSourceSites = (enabled = true) => {
  return useQuery({
    queryKey: ['source-sites'],
    queryFn: fetchSourceSites,
    select: (data) => data.data,
    enabled,
  })
}
// /source-sites GET API call using plannerRequest

const createProject = async (projectData: ProjectParamsInterface) => {
  const { data } = await requestV3({
    url: `/projects`,
    method: 'post',
    data: projectData,
  })
  return data
}

export const useCreateProjectData = ({
  onCreateProjectSuccess,
}: useCreateProjectDataParams) => {
  return useMutation({
    mutationFn: createProject,
    onSuccess: ({ data, message }) => {
      onCreateProjectSuccess(data.id, message)
    },
  })
}
